import { useEffect, useState, useContext } from 'react';
import CollectionContext from 'components/Collection/CollectionContext';
import { useSelector } from 'react-redux';
import graphql from 'api/graphql';
import { isUserOnJuke as getIsUserOnJuke } from 'store/reducers/trackers';
import logger from 'util/logger';

export default function useFetchNowPlaying({ contentTypeId, slug } = {}) {
  const isUserOnJuke = useSelector((state) => getIsUserOnJuke(state));
  const [playouts, setPlayouts] = useState(null);
  const { showNowPlayingInfo = true } = useContext(CollectionContext);

  useEffect(() => {
    let nowPlayingIntervalUpdate;
    let unmounted;
    async function fetchNowPlaying() {
      try {
        const response = await graphql.fetchUnderlineTrack({ slug });
        if (!unmounted) {
          setPlayouts(response);
        }
      } catch (error) {
        logger.error(`Error ${error} while fetchNowPlaying with graphQL for ${slug} | ${contentTypeId}`);
      }
    }

    const shouldFetchNowPlaying = contentTypeId === 'stationCollection' && showNowPlayingInfo;
    if (slug && shouldFetchNowPlaying) {
      if (isUserOnJuke) {
        fetchNowPlaying();
        nowPlayingIntervalUpdate = setInterval(fetchNowPlaying, 60000);
      } else {
        clearInterval(nowPlayingIntervalUpdate);
      }
    }
    return () => {
      clearInterval(nowPlayingIntervalUpdate);
      unmounted = true;
    };
  }, [slug, isUserOnJuke, showNowPlayingInfo, contentTypeId]);

  return playouts;
}
